import * as React from 'react';
import cn from 'clsx';

import * as styles from '../Link/styles.css';

export interface ITextProps {
  text: string;
  multiLine?: boolean;
}

/* oxlint-disable react/no-danger */
export const Text: React.FC<ITextProps> = props => {
  const { text, multiLine } = props;

  return (
    <span
      dangerouslySetInnerHTML={{
        __html: text,
      }}
      className={cn({ [styles['multiline']]: multiLine })}
      data-testid="agreement-text"
    />
  );
};

Text.displayName = 'Text';
